import { CAMPAIGN_STATUS } from './constants';

export const getCounts = (types) => {
    const counts = {
        all: '',
        user: '',
        live: '',
        ready: '',
        requested: ''
    };
    types.forEach((type) => {
        switch(type.status) {
            case CAMPAIGN_STATUS.ready:
                counts.ready = type['count'];
                break;
            case CAMPAIGN_STATUS.live:
                counts.live = type['count'];
                break;
            case CAMPAIGN_STATUS.requested:
                counts.requested = type['count'];
                break;
            default:
                counts.user = type['count'];
        }
        if (type.myCampaigns) {
            counts.user = type['count'];
        }
    });
    return counts;
}
